export default __webpack_public_path__ + "static/media/eye-open.05fc77d7.svg";